import styled, { createGlobalStyle } from 'styled-components';

import { Row } from 'components/Entities/DocumentSettingsTab/styles';

export const HeaderFooterHoverStyles = createGlobalStyle`
  .tiptap-page-header[data-hovered='true'],
  .tiptap-page-footer[data-hovered='true'] {
    background-color: ${({ theme }) => theme.palette.action.hover} !important;
  }

  .tiptap-page-header[data-hovered='true'] {
    border-bottom: 1px dashed ${({ theme }) => theme.palette.grey[400]};
  }

  .tiptap-page-footer[data-hovered='true'] {
    border-top: 1px dashed ${({ theme }) => theme.palette.grey[400]};
  }
`;

export const PageEdgeStyles = createGlobalStyle`
  .ProseMirror[class*='tiptap-pages-'] {
    border: none;
    box-shadow: 0 0 0 1px ${({ theme }) => theme.palette.divider};
  }

  .ProseMirror[class*='tiptap-pages-'] .tiptap-pagination-gap {
    border-top-color: ${({ theme }) => theme.palette.divider};
    border-bottom-color: ${({ theme }) => theme.palette.divider};
  }
`;

// Pages renders the open header/footer editor on <body> at z-index 1000.
export const HeaderFooterEditingStackStyles = createGlobalStyle`
  .notion-like-editor-header {
    z-index: 1003;
  }

  /* Wrapper prefix outranks the toolbar's own styled-components class. */
  .notion-like-editor-wrapper [data-tiptap-toolbar='true'] {
    z-index: 1002;
  }

  .tiptap-dropdown-menu {
    z-index: 1004;
  }

  /* The resizer writes an inline pixel height; max-width alone would squash the width and keep that height. */
  [data-header-footer-sub-type] .ProseMirror img {
    max-width: 100%;
    height: auto !important;
  }

  .tiptap-page-header[data-editing='true'] > *,
  .tiptap-page-footer[data-editing='true'] > * {
    visibility: hidden;
  }
`;

export const StyledEditButtonFloat = styled.div`
  z-index: 49;
  pointer-events: none;

  && button {
    pointer-events: auto;
    width: 28px;
    height: 28px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    background-color: ${({ theme }) => theme.palette.background.paper};
    box-shadow: ${({ theme }) => theme.shadows[1]};
  }

  && button:hover {
    background-color: ${({ theme }) => theme.palette.grey[100]};
  }

  && svg {
    width: 16px;
    height: 16px;
  }
`;

export const StyledPanelSettingRow = styled(Row)`
  grid-template-columns: minmax(0, 1fr) auto;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: start;
  padding: 0;

  .MuiSwitch-root {
    margin-right: -7px;
  }
`;

export const StyledPanelClip = styled.div<{ $height: number | null }>`
  position: absolute;
  top: 100%;
  right: 0;
  box-sizing: border-box;
  /* The left padding leaves room for the panel's shadow, which the clip would otherwise cut off. */
  width: calc(${({ theme }) => theme.spacing(28)} + ${({ theme }) => theme.spacing(6)});
  max-width: 100%;
  height: ${({ $height }) => ($height === null ? 'auto' : `${$height}px`)};
  padding-left: ${({ theme }) => theme.spacing(6)};
  overflow: hidden;
  pointer-events: none;
`;

export const StyledDockedPanel = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-left: 1px solid ${({ theme }) => theme.palette.divider};
  box-shadow: ${({ theme }) => theme.shadows.card};
`;

export const StyledPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1.25)};
  padding: ${({ theme }) => theme.spacing(1.25, 2)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const StyledPanelTitle = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: ${({ theme }) => theme.typography.h4.fontSize};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  line-height: ${({ theme }) => theme.typography.subtitle1.lineHeight};
`;

export const StyledPanelBody = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => theme.spacing(2)};
`;

export const StyledPanelSectionHeading = styled.span`
  display: block;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  font-weight: ${({ theme }) => theme.typography.h6.fontWeight};
  line-height: ${({ theme }) => theme.typography.caption.lineHeight};
  text-transform: uppercase;
`;

export const StyledPanelSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};

  & + & {
    margin: ${({ theme }) => theme.spacing(0, -2)};
    padding: ${({ theme }) => theme.spacing(1.5, 2, 0)};
    border-top: 1px solid ${({ theme }) => theme.palette.divider};
  }
`;

export const StyledInsertList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  margin: ${({ theme }) => theme.spacing(0, -1)};

  .tiptap-button {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const StyledHiddenFileInput = styled.input`
  display: none;
`;
